import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import GNumberField from "../../libs/textfield/GNumberField";
import GTextField from "../../libs/textfield/GTextField";
import type { IFoodAmount, IRecipe } from "../../shared/Recipes";
import FoodRow from "./FoodRow";
import { Button } from "@mui/material";
import { AddOutlined } from "@mui/icons-material";

export interface IRecipeEditorProps {
    recipe:IRecipe
    onDirty:(dirty:boolean,valid:boolean) => void
}
export default forwardRef((props:IRecipeEditorProps,ref:any) => {
    const {recipe} = props
    const [items,setItems] = useState<IFoodAmount[]>(props.recipe.foods.slice(0))
    const nameRef = useRef<any>()
    const servingRef = useRef<any>()
    const descRef = useRef<any>()
    const mounted = useRef<boolean>(false)

    useImperativeHandle(ref, () => ({
        get value() {
            return {
                name:nameRef.current?.value,
                servings:parseInt(servingRef.current?.value),
                description:descRef.current?.value,
                foods:items
            }
        }
    }))

    const onChange = () => {
        const dirty = recipe.name!=nameRef.current?.value || recipe.servings!=servingRef.current?.value || recipe.description!=descRef.current?.value || JSON.stringify(recipe.foods)!=JSON.stringify(items)
        const valid = !!nameRef.current?.value && !!servingRef.current?.value && !items.find(i => !i.id)
        props.onDirty(dirty, valid)
    }

    useEffect(() => {
        if (mounted.current) onChange()
        else mounted.current = true
    }, [items])

    const onAdd = () => { setItems(items => [...items,{id:0,amount:0,unit:"g"}]) }
    const onUpdate = (index:number,foodAmount:IFoodAmount) => { 
        setItems(items => {
            items.splice(index, 1, foodAmount)
            return [...items]
        }); 
    }
    const onDelete = (index:number) => {
        setItems(items => {
            items.splice(index, 1)
            return [...items]
        })
    }
    const foods = items.map( (food,i) => <FoodRow key={i.toString()+":"+food.id} index={i} foodIds={recipe.foods.map(f => f.id)} foodAmount={food} onUpdate={onUpdate} onDelete={onDelete}/> )
    return <div className="recipeEdit flex vert gap-24">
        <div className="flex gap-16">
            <GTextField className="flex1" floatLabel="Name" defaultValue={recipe.name} inputRef={nameRef} onChange={onChange}/>
            <GNumberField className="serving" floatLabel="Servings" defaultValue={recipe.servings?.toString() || ""} inputRef={servingRef} onChange={onChange}/>
        </div>
        <GTextField className="desc" multiline={true} floatLabel="Description" defaultValue={recipe.description || ""} inputRef={descRef} onChange={onChange}/>
        <div className="ingList">
            {foods}
            <Button className="colspan" startIcon={<AddOutlined/>} onClick={onAdd}>Add ingredient</Button>
        </div>
    </div>
   
})